import { usePageContentNoProxy } from "@RHCommerceDev/custom-providers/LocationProvider";
import { useMemo } from "react";
import { europeanCountries } from "@RHCommerceDev/resources/countries-config.json";

const useCountryMessage = countryCode => {
  const { pageContent } = usePageContentNoProxy();

  const stytchData = pageContent?.emailSignupContent;

  const messageToDisplay = useMemo(() => {
    const messageMap = {
      CA: stytchData?.For_C$225_annually,
      US: stytchData?.For_$200_annually,
      GB: stytchData?.For_200GB_annually
    };

    if (europeanCountries.includes(countryCode)) {
      return stytchData?.For_225EU_annually;
    }
    return messageMap[countryCode] || stytchData?.For_$200_annually;
  }, [countryCode, stytchData]);

  return messageToDisplay;
};

export default useCountryMessage;
